// eslint-disable-next-line import/prefer-default-export
export const ONBOARDING_NAVIGATION_ERROR = "Unable to proceed to the next step. Please try again or contact support.";
